import {createContext} from "react";

const AllReviewsContext = createContext();

export default AllReviewsContext;
